import React, { useContext } from "react";
import { Checkbox } from "./Checkbox";
import { TableContext } from "../index";
import { useLocation } from "react-router-dom";
import * as urlService from "./urlService";
import SortableHeaderContent from "./SortableHeaderContent";
/**
 * Table with row checkboxes.
 *
 * @param headers {array} - table headers.
 * @param children {array<component>} - rows to render.
 * @param elements {array<object>} - table content.
 */
export function CheckboxBaselineTable({ headers, children, elements, containsEditButton = true }) {

    const { config, setConfig } = useContext(TableContext);
    useLocation();
    const sort = urlService.getSort(true);
    const normalizedHeaders = headers.filter(Boolean);

    const onSelectAllClick = () => {
        const selectElements = elements.map(el => el.id);
        if (config.selectAll) {
            setConfig({ ...config, selected: [], rule: [], selectAll: false })
        } else {
            setConfig({ ...config, selected: selectElements, rules: elements, selectAll: true })
        }
    }

    return (
        <table className="oct_table table oct_table-striped dataTable no-footer dtr-inline collapsed">
            <thead>
                <tr>
                    <th data-orderable="false">
                        <Checkbox checked={config.selectAll} onClick={() => onSelectAllClick()} />
                    </th>
                    {normalizedHeaders.map((header, index) => {
                        const direction = header.sortKey ? sort[header.sortKey] : null;
                        const headerClassName = [
                            header.className || "",
                            header.sortKey ? "oct_mousecursor-pointer oct_table-sortable" : ""
                        ].filter(Boolean).join(" ");

                        return (
                            <th
                                key={index}
                                className={headerClassName}
                                width={header.width || "auto"}
                                onClick={header.onClick ? () => header.onClick() : undefined}
                                aria-sort={header.sortKey
                                    ? (direction === "asc" ? "ascending" : direction === "desc" ? "descending" : "none")
                                    : undefined}
                            >
                                <SortableHeaderContent
                                    label={header.name}
                                    sortable={Boolean(header.sortKey)}
                                    direction={direction}
                                />
                            </th>
                        );
                    })}
                    {containsEditButton && <th data-orderable="false"></th>}
                </tr>
            </thead>
            <tbody>
                {children.map((row, index) =>
                    <React.Fragment key={index}>
                        {row}
                    </React.Fragment>
                )}
            </tbody>


        </table>
    );
}
